<template>
  <v-container-principal>
    <template #header>
      <v-cabecalho
        nomePagina="Blocos"
        buscaPlaceHolder="Pesquisar por um bloco"
        backTo="/"
        v-on:search="(value) => (textoPesquisado = value)">
        <v-cabecalho-btn
          v-if="isAdministrador || isPrefeitura"
          pathTo="criarBloco"
          icone="mdi-plus"
          descricao="Novo Bloco">
        </v-cabecalho-btn>
      </v-cabecalho>
    </template>
    <v-data-iterator
      loading-text="Carregando blocos..."
      :items="arrayBlocos"
      :options.sync="options"
      :items-per-page="footerProps.pagination.itemsPerPage"
      :server-items-length="footerProps.pagination.itemsLength"
      :footer-props="footerProps"
      :loading="loading"
      @update:page="updatePage"
      @update:items-per-page="updateItemsPerPage">
      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="item in props.items"
            :key="item.id"
            cols="12"
            md="6"
            lg="4"
            xl="3">
            <v-card-bloco
              :id="item.id"
              :nomeBloco="item.attributes.descricao"
              @delete="deletaBloco" />
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </v-container-principal>
</template>

<script>
import VCabecalho from "@/components/VCabecalho"
import VCardBloco from "@/components/VCardBloco"
import VContainerPrincipal from "@/components/VContainerPrincipal"
import { RepositoryFactory } from "../../repositories/repositoryFactory"
import { mapActions, mapGetters } from "vuex"
import VCabecalhoBtn from "../../components/VCabecalhoBtn.vue"

const BLOCO_EXCLUIDO_SUCESSO = "Bloco excluído com sucesso!"

const blocoRepository = RepositoryFactory.get("bloco")

export default {
  components: {
    VContainerPrincipal,
    VCabecalho,
    VCardBloco,
    VCabecalhoBtn,
  },

  data: () => ({
    arrayBlocos: [],
    options: {
      page: 1,
      itemsPerPage: Number(localStorage.getItem("blocos.itemsPerPage")) || 8,
    },
    serverItemsLength: 0,
    loading: true,
    delayPesquisa: null,
    textoPesquisado: "",
  }),
  computed: {
    footerProps() {
      return {
        itemsPerPageText: "Itens por página",
        itemsPerPageOptions: [8, 16, 24, 32],
        pagination: {
          page: this.options.page,
          itemsPerPage: this.options.itemsPerPage,
          pageStart: 1,
          itemsLength: null,
        },
      }
    },
    ...mapGetters({
      isAdministrador: ["auth/isAdministrador"],
      isPrefeitura: ["auth/isPrefeitura"],
    }),
  },
  watch: {
    textoPesquisado: {
      handler() {
        if (this.delayPesquisa) {
          clearTimeout(this.delayPesquisa)
          this.delayPesquisa = null
        }
        this.delayPesquisa = setTimeout(() => {
          this.carregaBlocos()
        }, 200)
      },
    },
  },
  mounted() {
    this.carregaBlocos()
  },
  methods: {
    carregaBlocos({
      page = this.footerProps.pagination.page,
      itemsPerPage = this.footerProps.pagination.itemsPerPage,
    } = {}) {
      this.loading = true
      blocoRepository
        .searchByName(this.textoPesquisado, page, itemsPerPage)
        .then((res) => {
          this.loading = false
          this.arrayBlocos = res.data.data
          this.footerProps.pagination.itemsLength =
            res.data.meta.pagination.total
        })
        .catch((error) => {
          this.showError(error.response.data.error.message)
        })
    },
    updatePage(page) {
      this.carregaBlocos({ page })
    },

    updateItemsPerPage(itemsPerPage) {
      localStorage.setItem("blocos.itemsPerPage", itemsPerPage)
      this.carregaBlocos({ itemsPerPage })
    },

    deletaBloco(id) {
      blocoRepository
        .delete(id)
        .then(() => {
          this.showSucesso(BLOCO_EXCLUIDO_SUCESSO)
          this.carregaBlocos()
        })
        .catch((error) => {
          this.showError(error.response.data.error.message)
        })
    },
    ...mapActions("message", ["showSucesso", "showErro"]),
  },
}
</script>
